import React from 'react';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SuraCard from '../../../../components/SuraCard';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import { useTipification } from '../../../../hooks/useTipification';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    selectedCard: {
      background: theme.palette.background.default,
    },
  })
);
interface SelectionCardsProps {
  cards: { title: string; icon?: any; value: string | number }[];
  relatedField: string;
  id?: string;
}

const SelectionCards: React.FC<SelectionCardsProps> = ({
  cards,
  relatedField,
}) => {
  const { nextStep, updateAssistanceBody, assistance_body } =
    useAssistanceDataContext();
  const classes = useStyle();
  const { user } = useAuthDataContext();
  const { trackEvent, events } = useTipification();

  const selectCard = (
    value: string | number,
    title: string,
    tipificationKey?: string
  ) => {
    if (
      value === 'vehicle_stopped_while_driving' ||
      value === 'vehicle_wont_start'
    ) {
      dataLayerPush('asistencia_comoSucedió', user?.id, {
        fieldName: 'opcion_asistencia_comoSucedió',
        fieldValue:
          value === 'vehicle_stopped_while_driving'
            ? 'El vehículo se apago en movimiento'
            : 'El vehículo directamente no arranca',
      });
    } else if (value === 'no_spare_tire' || value === 'spare_tire') {
      dataLayerPush('asistencia_ruedaAuxilio', user?.id, {
        fieldName: 'opcion_asistencia_ruedaAuxilio',
        fieldValue:
          value === 'no_spare_tire'
            ? 'No tengo rueda de auxilio'
            : 'Si, tengo rueda de auxilio',
      });
    } else if (title === 'Necesito una grúa') {
      dataLayerPush('necesito_asistencia_grua', user?.id);
    } else {
      dataLayerPush('necesito_asistencia_opciones', user?.id, {
        fieldName: 'opcion_asistencia',
        fieldValue: title,
      });
    }
    if (tipificationKey) trackEvent(events[tipificationKey]);
    updateAssistanceBody({
      [relatedField]: value,
      [relatedField + '_title']: title,
    });
    nextStep(value);
  };

  return (
    <>
      {cards.map((card: any, index: number) => (
        <Grid item xs={12} sm={6} key={index}>
          <Box mr={3} mb={3}>
            <ButtonBase
              style={{ width: '100%' }}
              onClick={() => selectCard(card.value, card.title)}
            >
              <SuraCard
                className={
                  assistance_body[relatedField] === card.value
                    ? classes.selectedCard
                    : ''
                }
                style={{ width: '100%' }}
              >
                <Box
                  m={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      {card.icon ? (
                        <img src={card.icon} alt={card.title}></img>
                      ) : null}
                    </Box>
                    <Box ml={1}>
                      <Typography variant="body1">{card.title}</Typography>
                    </Box>
                  </Box>
                  <Box>
                    <RightIcon></RightIcon>
                  </Box>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>
        </Grid>
      ))}
    </>
  );
};

export default SelectionCards;
